export function bpsToPercent(bps: number | null | undefined, digits = 2): string {
  const v = Number(bps || 0) / 100
  return `${v.toFixed(digits)}%`
}

export function percentToBps(percent: number | string | null | undefined): number {
  const v = Number(percent || 0)
  if (!Number.isFinite(v)) return 0
  return Math.max(0, Math.round(v * 100))
}

